module.exports = __webpack_public_path__ + "static/img/section3Bg1.357e9052.png";